import React from 'react'
import { components } from 'react-select'

import { Box } from '@chakra-ui/react'
const CustomOption = ({ children, ...props }) => {
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps
  const newProps = { ...props, innerProps: rest }
  return (
    <Box _hover={{ bg: '#deebff', transitionDelay: '60ms' }} transition={'background 60ms'}>
      <components.Option {...newProps}>{children}</components.Option>
    </Box>
  )
}

export default CustomOption
